import React from 'react'
import ArchFull from '@assets/images/Tooth/ArchFull.svg'
import ArchUpper from '@assets/images/Tooth/ArchUpper.svg'
import ArchLower from '@assets/images/Tooth/ArchLower.svg'

export type ChartingView = 'full' | 'upper' | 'lower'

interface ChartingViewToggleProps {
  currentView: ChartingView
  onViewChange: (view: ChartingView) => void
}

const ChartingViewToggle = ({
  currentView,
  onViewChange,
}: ChartingViewToggleProps): React.ReactElement => {
  return (
    <div className="charting-view-toggle">
      <div className="charting-toggle-group">
        <button
          className={`charting-toggle-btn ${currentView === 'upper' ? 'active' : ''}`}
          onClick={() => onViewChange('upper')}
          title="Upper jaw"
        >
          <img
            src={ArchUpper}
            alt="Upper jaw"
            className="charting-toggle-icon"
          />
        </button>
        <button
          className={`charting-toggle-btn ${currentView === 'full' ? 'active' : ''}`}
          onClick={() => onViewChange('full')}
          title="Full mouth"
        >
          <img
            src={ArchFull}
            alt="Full mouth"
            className="charting-toggle-icon"
          />
        </button>
        <button
          className={`charting-toggle-btn ${currentView === 'lower' ? 'active' : ''}`}
          onClick={() => onViewChange('lower')}
          title="Lower jaw"
        >
          <img
            src={ArchLower}
            alt="Lower jaw"
            className="charting-toggle-icon"
          />
        </button>
      </div>
    </div>
  )
}

export default ChartingViewToggle
